export default __webpack_public_path__ + "static/media/Adjunta_credencial_ambosLados.2677aa1d.gif";